import {ChangeDetectorRef, Component, inject, Input} from "@angular/core";
import {SimClientStorageService, SimConfigurationService, SimUtilityService} from "@services";
import {Translations} from "@translations";
import {EventEmitterService} from "@event-emitter";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: "sim-timer-display",
	templateUrl: "./timer-display.component.html",
	styleUrl: "./timer-display.component.scss",
	providers: [EventEmitterService],
	standalone: false,
})
export class TimerDisplayComponent {
	readonly translate = inject(TranslateService);
	protected readonly T = Translations;

	@Input({required: true}) relativeTime: number = 0;
	@Input() startDate: Date | string = "";
	@Input() showAbsoluteTimeOverride: boolean | null = null;

	public constructor(
		private _simClientStorageService: SimClientStorageService,
		private _eventEmitterService: EventEmitterService,
		private _changeDetectorRef: ChangeDetectorRef,
	) {
		this._eventEmitterService.onShowAbsoluteTimeChanged.next({
			value: this.showAbsoluteTime,
		});
		this._eventEmitterService.onShowAbsoluteTimeChanged.subscribe((event) => {
			//needed if the parent component is marked as OnPush
			this._changeDetectorRef.markForCheck();
		});
	}

	public getAbsoluteTime(position: number): Date {
		return SimUtilityService.calculateAbsoluteTime(this.startDate, position);
	}

	public get shouldShowAbsoluteTime(): boolean {
		if (!SimConfigurationService.settings.enableAbsoluteTimeInsteadOfRelativeTimeToggle) {
			return false;
		}

		if (this.hasOverride) {
			return !!this.showAbsoluteTimeOverride;
		}

		return this.showAbsoluteTime;
	}

	public toggleTimeDisplayType() {
		//only toggle if showAbsoluteTimeOverride is not set
		if (!this.hasOverride && SimConfigurationService.settings.enableAbsoluteTimeInsteadOfRelativeTimeToggle) {
			this.showAbsoluteTime = !this.showAbsoluteTime;
		}
	}

	private get hasOverride(): boolean {
		return this.showAbsoluteTimeOverride !== null && this.showAbsoluteTimeOverride !== undefined;
	}

	private get showAbsoluteTime(): boolean {
		return this._simClientStorageService.getLocalData("showAbsolute") === "true";
	}

	private set showAbsoluteTime(value: boolean) {
		this._simClientStorageService.setLocalData("showAbsolute", value.toString());
		this._eventEmitterService.onShowAbsoluteTimeChanged.next({value});
	}
}
